import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import icons from '../../icons';
import Banner from '../Banner/Banner';
import IconButton from '../Buttons/IconButton/IconButton';
import style from './Menu.module.css';
import Option from './Option/Option';


const checkIOS = () => {
    if (navigator.standalone) {
        return false;
    }

    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i)
    const isIOS = isIPad || isIPhone;
    const isSafari = isIOS && webkit && !ua.match(/CriOS/i);

    return isIOS && isSafari;
};

const Menu = props => {
    const { data, user, offline: appOffline, setPage: setGlobalPage, page: globalPage, showNavBar, hideNavBar } = useContext(AppContext);

    const [page, setPage] = useState(props.page);

    const hide = e => {
        e?.stopPropagation();
        setPage(null);
        showNavBar();
        if (globalPage.from)
            setGlobalPage({ page: globalPage.from });
    };

    useEffect(() => {
        if (page) 
            hideNavBar();
    }, [page]);

    return <main className={ style.main }>
        <section className={ style.topSection }>
            <div className={ style.flex }>
                <h1 className={ style.header }>Menu</h1>
                <IconButton text="Premium" icon={ icons.premium_icon } style={{ height: "fit-content", width: "fit-content", padding: ".75rem .25rem" }} iconStyle={{ marginLeft: ".5rem", marginTop: "0", marginBottom: "0" }} textStyle={{ marginTop: "0", marginBottom: "0", marginLeft: ".5rem", marginRight: ".5rem" }} background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" fontSize=".8rem" iconDimensions="1rem" onClick={ () => setPage("premium") } />
            </div>
        </section>
        <Option top="5vh" left="80vw" hide={ hide } title="Premium" selected={ page === "premium" } page="premium" style={{ "--item_background": "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} />
        <Banner style={{ marginBottom: "1rem" }} />
        <h2 className={ style.sectionHeader }>Profilo e notifiche</h2>
        <section className={ style.items } style={{ "--item_background": "linear-gradient(to top, #0581e6, rgb(16, 0, 240))" }}>
            <div className={ style.item } onClick={ () => setPage("profile") }>
                <img src={ user?.profilePicture ?? icons.cartoon_avatar_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Profilo</h4>                
                <Option top="18vh" left="5vw" hide={ hide } title="Profilo" selected={ page === "profile" } page="profile" />
            </div>
            { !checkIOS() && <div className={ style.item } onClick={ () => setPage("notifications") }>
                <img src={ icons.notification_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Notifiche</h4>                
                <Option top="18vh" left="37vw" hide={ hide } title="Notifiche" selected={ page === "notifications" } page="notifications"  />
            </div> }
            {/* <div className={ style.item } onClick={ () => setGlobalPage({ page: "profile" }) }>
                <img src={ icons.settings_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Altro</h4>
                <Option top="18vh" left="69vw" hide={ hide } title="Altro" selected={ page === "other" } page="other"  />
            </div> */}
        </section>
        <h2 className={ style.sectionHeader }>La tua classe</h2>
        <section className={ style.items } style={{ "--item_background": "linear-gradient(to top, rgb(89, 0, 255), rgb(81, 0, 187))" }}>
            <div className={ style.item } onClick={ () => setPage("subjects") }>
                <img src={ icons.subjects_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Materie</h4>                
                <Option top="52vh" left="5vw" hide={ hide } title="Materie" selected={ page === "subjects" } page="subjects" />
            </div>
            <div className={ style.item } onClick={ () => setPage("timetable") }>
                <img src={ icons.timeline_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Orario</h4>                
                <Option top="52vh" left="37vw" hide={ hide } title="Orario" selected={ page === "timetable" } page="timetable" timetableDay={ props.timetableDay } />
            </div>
            {/* TODO: fetch only school users <div className={ style.item } onClick={ () => setPage("school") }>
                <img src={ icons.school_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Istituto</h4>                
                <Option top="69vh" left="69vw" hide={ hide } title="Il tuo istituto" selected={ page === "school" } page="school" />
            </div> */}
            <div className={ style.item } onClick={ () => setPage("calendar") }>
                <img src={ icons.calendar_orange_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Calendario</h4>                
                <Option top="52vh" left="69vw" hide={ hide } title="Calendario" selected={ page === "calendar" } page="calendar"  />
            </div>
        </section>
        <h2 className={ style.sectionHeader }>Social e integrazioni</h2>
        <section className={ style.items } style={{ "--item_background": "linear-gradient(to top, #237A57, #093028)" }}> {/* #302b63, #0f0c29 */}
            <div className={ style.item } onClick={ () => window.open("https://www.instagram.com/schooldiary.app/") }>
                <img src={ icons.instagram_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Instagram</h4>
            </div>
            {/* <div className={ style.item } onClick={ () => window.open("https://discord.gg/5RQCe5Snwq") }>
                <img src={ icons.discord_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Discord</h4>
            </div> */}
            <div className={ style.item } onClick={ () => setPage("classroom") }>
                <img src={ icons.classroom_icon } className={ style.itemIcon } style={{ width: "3rem" }}></img>
                <h4 className={ style.itemHeader }>Classroom</h4>                
                <Option top="69vh" left="37vw" hide={ hide } title="Classroom" selected={ page === "classroom" } page="classroom"  />
            </div>
            <div className={ style.item } onClick={ () => setPage("register") }>
                <img src={ icons.classeviva_icon } className={ style.itemIcon } style={{ width: "3rem" }}></img>
                <h4 className={ style.itemHeader }>Registro</h4>                
                <Option top="69vh" left="69vw" hide={ hide } title="Registro elettronico" selected={ page === "register" } page="register"  />
            </div>
            {/* <div className={ style.item } onClick={ () => window.location.href = "/discord" }>
                <img src={ icons.discord_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Discord</h4>                
                <Option top="52vh" left="69vw" hide={ hide } title="Discord" selected={ page === "discord" } page="discord"  />
            </div> */}
        </section>
        <h2 className={ style.sectionHeader }>Altro</h2>
        <section className={ style.items } style={{ "--item_background": "linear-gradient(to top, rgb(116, 115, 115), rgb(82, 82, 82))" }}>
            <div className={ style.item } onClick={ () => setPage("bugReport") }>
                <img src={ icons.warning_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Bug report</h4>
                <Option top="86vh" left="5vw" hide={ hide } title="Bug report" selected={ page === "bugReport" } page="bugReport"  />
            </div>
            {/* <div className={ style.item } onClick={ () => setPage("betaTester") }>
                <img src={ icons.settings_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Beta tester</h4>
                <Option top="86vh" left="37vw" hide={ hide } title="Beta tester" selected={ page === "betaTester" } page="betaTester"  />
            </div> */}
            <div className={ style.item } onClick={ () => window.location.href = "/cookies" }>
                <img src={ icons.cookies_icon } className={ style.itemIcon }></img>
                <h4 className={ style.itemHeader }>Cookies</h4>
            </div>
        </section>
    </main>;
};

export default Menu;
